module.exports = __webpack_public_path__ + "img/o.74592cb3.jpg";